export const introduce = {
  text: `### 使用方法
  + 我们可以通过该指标非常准确地识别每个宏观周期的价格高点（将顶部确定在几天之内）：
  + • 红色区域（指标> 50k） ：市场过热，有回调风险。
  + • 绿色区域（指标< 300） ：市场处于底部区域。
  
  ### 指标原理
  + 已实现比率 = 已实现hodl wave 一周波段 ÷ 一年至两年波段
  + RHODL = 已实现比率 * 市场天数
  + 当1周的价值明显高于1-2年时，是市场过热的信号。
  + 如果想对该指标有更深入的了解，可以参考 [已实现HODL比率](https://positivecrypto.medium.com/bitcoin-realized-hodl-ratio-9023db15a559)

  ### 创作者
  该指标由 [Philip Swift](https://twitter.com/PositiveCrypto) 创建`,
  height: 1540,
};
